import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "services-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "professional-development-blurb",
  class: "text-blue"
}, " CARE Behavioral Health provides trainings on specific “gold standard” instruments that are typically used to evaluate individuals suspected of having ASD. They also provide workshops on how to differentiate ASD from other disorders and how to identify co-morbid conditions that are common to individuals with ASD. Staff development training is offered by CARE BH on how to conduct Functional Behavior Assessments (FBAs) and Behavior Intervention Plans (BIPs) in order to address challenging behaviors exhibited by students. ", -1)
const _hoisted_3 = { class: "text-blue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StandardPageHeader = _resolveComponent("StandardPageHeader")!
  const _component_LinkList = _resolveComponent("LinkList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StandardPageHeader, {
      icon: '/icons/team-collaboration-icon.svg',
      title: 'Professional Development Services'
    }),
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DevelopmentServices, (section, sectionKey) => {
      return (_openBlock(), _createElementBlock("div", {
        key: sectionKey,
        class: "list-section mlr-auto"
      }, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.makeTitle(sectionKey)), 1),
        _createVNode(_component_LinkList, {
          class: "flex column",
          "link-section": section,
          "text-color-class": 'text-link-blue',
          internal: true
        }, null, 8, ["link-section"])
      ]))
    }), 128))
  ]))
}